import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kt-visual-identification',
  templateUrl: './visual-identification.component.html',
  styleUrls: ['./visual-identification.component.scss']
})
export class VisualIdentificationComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
